import React, { useEffect, useState } from 'react'
import UserLayout from '../../../components/layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../../components/elements/Loader'
import EmptyState from '../../../components/elements/EmptyState'
import { fetchStudents } from '../../../store/actions/studentsActions'
import StudentCard from '../../../components/partials/students/StudentCard'

const Students = () => {
  const dispatch = useDispatch()
  const studentsSelector = useSelector((state => state.students))
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(20);

  useEffect(() => {
    dispatch(fetchStudents('', page, perPage))
    return () => {
      
    };
  }, [page, perPage, dispatch]);

  return (
    <UserLayout>
      <div className='w-full xl:p-8'>
        <div className='w-full flex justify-between'>
          <div>
            <h3 className='text-lg font-medium'>Your Wards at Vaatia College Makurdi</h3>
          </div>
        </div>

        {studentsSelector.loadingStudents ? 
          <Loader />
          :
          <>
            {studentsSelector.students?.students?.length > 0 ? <div className='mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-8'>
              {studentsSelector?.students?.students?.map((student, studentIndex)=>(
                <div key={studentIndex}>
                  <StudentCard student={student} />
                </div>
              ))}
            </div>
              : 
              <div className='mt-24 w-full lg:w-1/2 mx-auto'>
                <EmptyState emptyStateText={`You have no wards schooling to Vaatia College Makurdi yet!`} />
              </div>

            }
          </>
        }
      </div>
    </UserLayout>
  )
}

export default Students